import { notification } from 'antd';

import { USER_LOGIN } from '../common/routes';

export default function notifySessionExpired() {
  notification.error({
    title: 'You are logged out due to inactivity.',
    duration: false,
    description: <a href={`${USER_LOGIN}`}>Go to login page.</a>,
  });
}
